@if (html()) {
  <span class="ideals-tooltip__content" [innerHTML]="content()"></span>
} @else {
  <span class="ideals-tooltip__content">{{ content() }}</span>
}
